// src/Document.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Document_default = createIcon({
  displayName: "Document",
  viewBox: "0 0 24 25",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M22 0.500244H6C5.73478 0.500244 5.48043 0.605601 5.29289 0.793137C5.10536 0.980674 5 1.23503 5 1.50024V21.0002C5 21.3981 4.84196 21.7796 4.56066 22.0609C4.27936 22.3422 3.89782 22.5002 3.5 22.5002C3.10218 22.5002 2.72064 22.3422 2.43934 22.0609C2.15804 21.7796 2 21.3981 2 21.0002V14.5002H4V12.5002H1C0.734784 12.5002 0.48043 12.6056 0.292893 12.7931C0.105357 12.9807 0 13.235 0 13.5002L0 21.0002C0 21.9285 0.368749 22.8187 1.02513 23.4751C1.6815 24.1315 2.57174 24.5002 3.5 24.5002H20C20.7944 24.4963 21.5552 24.179 22.117 23.6172C22.6787 23.0555 22.9961 22.2947 23 21.5002V1.50024C23 1.23503 22.8946 0.980674 22.7071 0.793137C22.5196 0.605601 22.2652 0.500244 22 0.500244V0.500244ZM19 19.5002H9V17.5002H19V19.5002ZM19 14.5002H9V12.5002H19V14.5002ZM19 9.50024H9V4.50024H19V9.50024Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  Document_default
};
